import { useEffect, useState } from "react";
import axios from "axios";
import { useRecoilState, useRecoilValue } from "recoil";
import { appVersion, userState } from "../states/userState";
import { auth, provider } from "../firebase";
import {
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
} from "firebase/auth";
import {
  getUserFromLocalStorage,
  setUserToLocalStorage,
} from "../functions/localStorageManager";
import { modeState } from "../states/modeState";
import { factories } from "../commons/factories";
import { productItems } from "../commons/productItems";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [user, setUser] = useRecoilState(userState);
  const mode = useRecoilValue(modeState);
  /**
   * 0:成功、1:Google認証エラー、2:kintone照合エラー
   */
  const loginWithGoogle = async () => {
    //Google認証を実行
    const result = await signInWithGoogle();

    if (!result) return 1;
    const googleUser = result.user;
    // 必要なユーザー情報を抽出
    const uid = googleUser.uid;
    const photoURL = googleUser.photoURL;
    const displayName = googleUser.displayName;
    const email = googleUser.email;

    //Recoilにユーザ情報をセット
    setUser({
      ...user,
      appVersion: appVersion,
      isAuth: true,
      workerName: displayName,
      email: email,
      photoURL: photoURL,
      mode: mode,
      filters: {
        productNo: "",

        drawingNames: [], //図面名・タブ名（複数選択）
        excludeDrawingNames: [], //除外図面名（複数選択）
        documentNames: [], //文書名（複数選択）
        excludeDocumentNames: [], //除外文書名（複数選択）
        factories: factories.map((factory) => factory.id), //工場（複数選択）
        productItems: productItems.map((product) => product.id), //製品項目（複数選択）
        isUpdateEnable: false,
        drawingUpdFrm: "",
        drawingUpdTo: "",
        keywords: "",
        latestOnly: true,
      },
    });
    //LocalStorageにユーザ情報をセット
    setUserToLocalStorage({
      ...user,
      appVersion: appVersion,
      isAuth: true,
      workerName: displayName,
      email: email,
      photoURL: photoURL,
      mode: mode,
      filters: {
        productNo: "",
        drawingNames: [], //図面名・タブ名（複数選択）
        excludeDrawingNames: [], //除外図面名（複数選択）
        documentNames: [], //文書名（複数選択）
        excludeDocumentNames: [], //除外文書名（複数選択）
        factories: factories.map((factory) => factory.id), //工場（複数選択）
        productItems: productItems.map((product) => product.id), //製品項目（複数選択）

        isUpdateEnable: false,
        drawingUpdFrm: "",
        drawingUpdTo: "",
        keywords: "",
        latestOnly: true,
      },
    });

    return 0;
  };

  return { loginWithGoogle, loading, error };
};

const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider); // Google認証を試みる
    return result; // 認証が成功した場合はtrueを返す
  } catch (error) {
    alert(error.message); // エラーメッセージを表示
    return false; // 認証が失敗した場合はfalseを返す
  }
};

// const signInWithGoogle = async () => {
//   try {
//     await signInWithRedirect(auth, provider); // Google認証を試みる
//     const result = await getRedirectResult(auth);
//     return result; // 認証が成功した場合はtrueを返す
//   } catch (error) {
//     alert(error.message); // エラーメッセージを表示
//     return false; // 認証が失敗した場合はfalseを返す
//   }
// };

// const getUserFromKintone = async (email) => {
//   try {
//     const result = await axios.get(
//       `https://kintoneconnect-6ywpmfhxlq-an.a.run.app/api/next/nextuser/${email}`
//     );
//     return result.data; // 認証が成功した場合はtrueを返す
//   } catch (error) {
//     alert(error.message); // エラーメッセージを表示
//     return false; // 認証が失敗した場合はfalseを返す
//   }
// };
